function Paso1({ tipoServicio, setTipoServicio, tipoDesplazamiento, setTipoDesplazamiento, servicioUrgente, setServicioUrgente, cambiarTipoYpaso2, divisaServicio }) {


  return (
  <div className="card border-0 shadow-sm mb-4">
    <div className="card-body">

      {/* Paso 1 */}
      <div className="d-flex align-items-center justify-content-between flex-wrap gap-2">
        <div>
          <h5 className="mb-1">Paso 1</h5>
          <small className="text-muted">Selecciona el tipo de servicio</small>
        </div>

        <div className="d-flex align-items-center gap-2 flex-wrap">
          <span className="badge rounded-pill border" style={{ backgroundColor: "var(--color-bg-accent-subtle)", color: "var(--color-text-primary)", borderColor: "var(--azul-cielo)", fontWeight: 600 }}>
            {divisaServicio === "USD" ? "🇺🇸 USD" : "🇨🇴 COP"}
          </span>
          <span className="badge text-bg-primary">1 / 5</span>
        </div>
      </div>

      {/* TITULO */}
      <h3 className="mt-3 mb-2">¿Qué tipo de servicio es?</h3>
      <p className="text-muted mb-3">
        Elige si tu servicio se presta de forma presencial o por internet (digital).
      </p>


      {/* PRESENCIAL O DIGITAL */}
      <div className="row g-3 mt-1">
      {/* PRESENCIAL */}
        <div className="col-12 col-md-6">
          <button
            type="button"
            className={`btn w-100 py-2 fw-semibold ${tipoServicio === "Presencial" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => {
              setTipoServicio("Presencial");
              setTipoDesplazamiento("Domicilio");
            }}
          >
            <i className="bi bi-geo-alt me-2"></i>
            Presencial
          </button>
        </div>

        {/* DIGITAL */}
        <div className="col-12 col-md-6">
          <button
            type="button"
            className={`btn w-100 py-2 fw-semibold ${tipoServicio === "Digital" ? "btn-primary" : "btn-outline-primary"}`}
            onClick={() => {
              setTipoServicio("Digital");
              setTipoDesplazamiento("Nodefinido");
              setServicioUrgente(false);
            }}
          >
            <i className="bi bi-laptop me-2"></i>
            Digital
          </button>
        </div>
      </div>


      {/* DOMICILIO O ENLOCAL */}
      {tipoServicio === "Presencial" && (
        <div className="mt-4">
          <p className="mb-3 fw-semibold fs-5">¿Cómo se prestará este servicio?</p>
          <div className="row g-3">
            {/* DOMICILIO */}
            <div className="col-12 col-md-6">
              <button
                type="button"
                className={`btn w-100 py-2 fw-semibold ${tipoDesplazamiento === "Domicilio" ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setTipoDesplazamiento("Domicilio")}
              >
                <i className="bi bi-house-door me-2"></i>
                Domicilio
              </button>
            </div>

            {/* ENLOCAL */}
            <div className="col-12 col-md-6">
              <button
                type="button"
                className={`btn w-100 py-2 fw-semibold ${tipoDesplazamiento === "EnLocal" ? "btn-primary" : "btn-outline-primary"}`}
                onClick={() => setTipoDesplazamiento("EnLocal")}
              >
                <i className="bi bi-shop me-2"></i>
                En local
              </button>
            </div>
          </div>
        </div>
      )}

      {/* NOTA EXPLICATIVA */}
      <div className="mt-3">
        <div className="alert alert-info mb-0">
          {tipoServicio === "Digital" && (
            <> <b>Nota:</b> este servicio se prestará por internet, sin desplazamientos físicos. Ideal para asesorías, diseño, edición, desarrollo, marketing y otros servicios digitales. </>
          )}

          {tipoServicio === "Presencial" && tipoDesplazamiento === "Domicilio" && (
            <> <b>Nota:</b> prestarás este servicio desplazándote hasta la ubicación del cliente. Asegúrate de definir bien tu cobertura y disponibilidad. </>
          )}

          {tipoServicio === "Presencial" && tipoDesplazamiento === "EnLocal" && (
            <> <b>Nota:</b> el cliente deberá desplazarse hasta tu local o punto de atención para recibir el servicio. Procura que la ubicación esté bien definida. </>
          )}

          {tipoServicio === "Presencial" && tipoDesplazamiento !== "Domicilio" && tipoDesplazamiento !== "EnLocal" && (
            <> <b>Nota:</b> este servicio será presencial. Ahora selecciona si lo prestarás a domicilio o en tu local para continuar configurándolo correctamente. </>
          )}
        </div>
      </div>


      {/* CHECKBOX SERVICIO UGENTE */}
      {tipoServicio === "Presencial" && (
        <div className="mt-4">
          {/* CHECKBOX */}
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              id="servicioUrgente"
              checked={servicioUrgente}
              onChange={(e) => setServicioUrgente(e.target.checked)}
            />
            <label className="form-check-label fw-semibold" htmlFor="servicioUrgente">
              Marcar como servicio urgente
            </label>
          </div>
          {/* MENSAJE ANTES DE OPRIMIR */}
          {!servicioUrgente && (
            <div className="text-muted mt-2" style={{ fontSize: "14px" }}>
              Aumenta el valor de tu servicio por disponibilidad inmediata y recibe reservas con menor anticipación.
            </div>
          )}

          {/* MENSAJE CUANDO SE OPRIME CHECKBOX */}
          {servicioUrgente && (
            <div className="alert alert-warning mt-3 mb-0" role="alert">
              <strong>Servicio urgente activado</strong>
              <br /><br />
              Al activar esta opción, permitirás reservas <strong>desde las siguientes 2 horas</strong> hasta las primeras <strong>24 horas</strong> a partir del momento en que el cliente reserve — ese rango se cobrará como urgente. Pasadas las 24 horas, el servicio vuelve al costo normal.
              <br /><br />
              <strong>¿Qué implica esto?</strong>
              <br />
              • Las reservas urgentes pueden incluir hasta un <strong>35% adicional</strong> sobre el precio del servicio.
              <br />
              • Tendrás mayor visibilidad y posibilidad de recibir más reservas.
              <br />
              • Tus valoraciones pueden mejorar al ofrecer disponibilidad inmediata.
              <br />
              • Solo aplica a servicios que se cobran por <strong>horas</strong> (citas) — no es compatible con servicios que se cobran por días.
              <br />
              • Solo estará disponible con <strong>horarios exactos</strong> — los horarios flexibles no son compatibles con el modo urgente.
              <br /><br />
              ⚠️ Es importante cumplir con estos servicios sin cancelaciones, ya que esto impacta directamente tu reputación dentro de la plataforma.
            </div>
          )}
        </div>
      )}

      {/* BOTÓN CONTINUAR */}
      <div className="d-flex justify-content-end mt-3">
        <button type="button" className="btn btn-primary" onClick={cambiarTipoYpaso2}>
          Continuar
        </button>
      </div>
    </div>
  </div>
  );
}

export default Paso1;